module.exports = __webpack_public_path__ + "img/Logo_A_White.1c6292c5.png";